import { jsx as _jsx } from "react/jsx-runtime";
const ALIGN_MAP = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    stretch: "stretch",
};
const JUSTIFY_MAP = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    between: "space-between",
    around: "space-around",
};
export function Stack({ direction = "column", gap = "md", align = "stretch", justify = "start", wrap = false, style, ...rest }) {
    return (_jsx("div", { style: {
            display: "flex",
            flexDirection: direction,
            gap: `var(--hydrax-space-${gap})`,
            alignItems: ALIGN_MAP[align],
            justifyContent: JUSTIFY_MAP[justify],
            flexWrap: wrap ? "wrap" : "nowrap",
            ...style,
        }, ...rest }));
}
//# sourceMappingURL=Stack.js.map